export default __webpack_public_path__ + "static/iconFlor4-5b3073fe42298f975e7b05f3ef45638a.png";